import cn from 'classnames'
import moment from 'moment'
import Image from 'next/image'
import Link from 'next/link'
import React from 'react'
import icGraveyard from 'src/assets/ic-graveyard.png'
import { HtmlContentViewer } from 'src/components/global/HtmlContentViewer/HtmlContentViewer'
import { ISolutionListItemFragment } from 'src/graphql/generated/hooks'
import { removeTags } from 'src/utils/removeTags'

import CategoryList from '../VendorList/VendorListItem/CategoryList'
import VendorLogo from '../VendorList/VendorListItem/VendorLogo'

export interface GraveyardListItemProps {
  solution: ISolutionListItemFragment
  href: string
}

export const GraveyardListItem: React.FC<GraveyardListItemProps> = ({ solution, href }) => {
  const content = removeTags(solution?.description || '')
  const listdate = solution?.graveyard?.date
  const formatedDate = listdate ? moment(listdate).format('MMM DD, YYYY') : null
  const subTopics = (solution?.subTopics || []).map((subTopic) => {
    return subTopic ? subTopic : ''
  })

  return (
    <div className={cn('flex', 'flex-row', 'items-center', 'pt-[14px] pb-[8px]')}>
      <div className="flex flex-row w-full items-center">
        <Link href={href ? href : ''}>
          <VendorLogo
            className="bg-white rounded-[.5rem] drop-shadow-md mr-[1.75rem] w-[80px] h-[80px] md:w-[120px] md:h-[120px] flex items-center justify-center"
            src={solution.logo}
          />
        </Link>
        <div className="grow flex-1">
          <div className="w-full flex md:flex-grow flex-col justify-between">
            <div className="w-full flex flex-col justify-between">
              <Link
                href={href ? href : ''}
                className="cursor-pointer md:text-[1.125rem] text-[1.0rem] text-textdark font-secondary font-bold mb-1.5"
              >
                {solution.displayName}
              </Link>
              <div className="flex flex-row mb-1.5 h-[20px] w-fit bg-burlyWood rounded-[3px] items-center pl-[5px] pr-[5px]">
                <Image src={icGraveyard} alt="" width={'20'} height={'15'} />
                <p className="pl-[5px] h-[20px] text-textdark font-primary text-[15px] font-bold leading-[18px]">
                  {formatedDate}
                </p>
              </div>
            </div>
          </div>
          <HtmlContentViewer className="text-[0.815rem] pr-[2rem] showmore-text break-all" html={content} />
          <CategoryList className="mb-[6px]" listCategory={subTopics} />
        </div>
      </div>
    </div>
  )
}
